import { render } from "./CollectionGallery.vue?vue&type=template&id=5d1326da&ts=true&lang=pug"
import script from "./CollectionGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionGallery.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__